import { useId, useState } from 'react';
import { Info } from 'lucide-react';

const PRESETS = [1,2,3,4,5,10,20,30,40,50,100,125,150,200,300,400,500,1000,2000,5000,10000];

const LeverageSelector = ({value=100,onChange,showInfo=true,className='',testId}) => {
  const id=useId().replace(/:/g,'');
  const prefix=testId||`leverage-${id}`;
  const [custom,setCustom]=useState(!PRESETS.includes(Number(value)));
  const [draft,setDraft]=useState(String(value));
  const [error,setError]=useState('');
  const apply=()=>{
    const raw=draft.trim().replace(/^1\s*:\s*/,'');
    const number=Number(raw);
    if(!/^\d+$/.test(raw)||!Number.isInteger(number)||number<1||number>10000){setError('1 ile 10000 arasında tam sayı girin.');return;}
    setError('');onChange(number);
  };
  return <div className={`min-w-0 ${className}`} data-testid={`${prefix}-control`}>
    <select aria-label="Kaldıraç" className="sirix-form-select w-full min-w-0" data-testid={`${prefix}-select`} value={custom?'custom':Number(value)} onChange={event=>{setError('');if(event.target.value==='custom'){setCustom(true);setDraft(String(value));}else{setCustom(false);onChange(Number(event.target.value));}}}>
      {PRESETS.map(number=><option key={number} value={number}>{`1:${number}`}</option>)}
      <option value="custom">Özel değer</option>
    </select>
    {custom&&<div className="flex flex-wrap gap-2 mt-2">
      <input aria-label="Özel kaldıraç" data-testid={`${prefix}-custom`} className="sirix-form-input w-full min-w-0" value={draft} onChange={event=>setDraft(event.target.value)} onBlur={apply} onKeyDown={event=>{if(event.key==='Enter'){event.preventDefault();apply();}}}/>
      <button type="button" className="sirix-btn sirix-btn-secondary" data-testid={`${prefix}-apply`} onClick={apply}>Uygula</button>
    </div>}
    {error&&<p role="alert" className="text-xs text-red-600 mt-1" data-testid={`${prefix}-error`}>{error}</p>}
    {showInfo&&<p className="text-xs text-gray-500 mt-1" data-testid={`${prefix}-margin`}>Teminat: %{(100/value).toLocaleString('tr-TR',{maximumFractionDigits:2})}</p>}
  </div>;
};

export const LeverageBadge = ({value,onClick,editable=false}) => {
  const id=useId().replace(/:/g,'');
  return <span data-testid={`leverage-badge-${id}`} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-mono ${editable?'bg-[#00BCD4]/10 text-[#00BCD4] cursor-pointer':'bg-gray-100 text-gray-700'}`} onClick={onClick}><Info size={12}/>1:{value||100}</span>;
};
export default LeverageSelector;